import {
  domen,
  domenUploadFile,
  invocesToken,
  maxInvocePrice,
  Meta,
  minInvocePrice,
  existedInvocesToken,
  rootToken,
  toEditToken,
  toReadonlyToken,
  newInvocesToken,
  actionsToken,
  saveToken,
  paymentTypesColors,
  deleteInvocesToken,
  noExistedInvocesToken,
  marketOrdersToken,
} from '../defaults';

/* eslint-disable */
export const meta: Meta = {
  triggers: [
    {
      events: ['load'],
      targets: [invocesToken],
      handlers: [
        'set-not-first-render',

        'load-payment-types-list',
        'add-invoces-pending',

        'load-invoces-list',
        'add-invoces-pending',
      ],
      expr: {
        type: 'func',
        value: `({hashMap}) => hashMap['${invocesToken}'].data.customData.isFirstRender`,
      },
    },

    {
      events: ['change-readonly'],
      targets: [invocesToken],
      handlers: [
        'resolve-to-edit-button',
        'resolve-to-readonly-button',
        'resolve-to-save-button',
        'resolve-inputs-readonly',
        'resolve-hide-or-show-actions',
      ],
    },
    {
      events: ['on-change-any-data-param'],
      targets: [invocesToken],
      handlers: ['show-or-hide-main-loader'],
    },
    {
      events: ['data-fetch-success'],
      targets: [invocesToken],
      handlers: ['subtract-invoces-pending', 'set-loaded-payment-types-list'],
      expr: {
        type: 'func',
        value: `({sourceAction}) => sourceAction.token === 'load-payment-types-list'`,
      },
    },
    {
      events: ['data-fetch-success'],
      targets: [invocesToken],
      handlers: [
        'subtract-invoces-pending',
        'set-loaded-invoces-list',
        'resolve-show-no-existed-invoces-text',
      ],
      expr: {
        type: 'func',
        value: `({sourceAction}) => sourceAction.token === 'load-invoces-list'`,
      },
    },
    {
      events: ['data-fetch-error'],
      targets: [invocesToken],
      handlers: ['subtract-invoces-pending', 'show-modal-error'],
    },
  ],
  actions: [
    {
      kind: 'changes',
      token: 'clear-deleted-invoces',
      spec: {
        target: deleteInvocesToken,
        changes: { 'data.value': { type: 'val', value: [] } },
      },
    },

    {
      kind: 'func',
      token: 'clear-existed-invoces',
      spec: {
        func: `({hashMap, source, setSduiSource}) => {
  const existedInvoces = source.child.find(({token}) => token === '${rootToken}').child.find(({token}) => token === '${invocesToken}').child.find(({token}) => token === '${existedInvocesToken}').child     
  existedInvoces.splice(0, existedInvoces.length)
  setSduiSource({source, add: true})
}`,
      },
    },

    {
      kind: 'func',
      token: 'clear-new-invoces',
      spec: {
        func: `({hashMap, source, setSduiSource}) => {
  const newInvoces = source.child.find(({token}) => token === '${rootToken}').child.find(({token}) => token === '${invocesToken}').child.find(({token}) => token === '${newInvocesToken}').child     
  newInvoces.splice(0, newInvoces.length)
  setSduiSource({source, add: true})
}`,
      },
    },

    {
      kind: 'func',
      token: 'clear-market-orders',
      spec: {
        func: `({hashMap, source, setSduiSource}) => {
  const marketOrders = source.child.find(({token}) => token === '${rootToken}').child.find(({token}) => token === '${invocesToken}').child.find(({token}) => token === '${marketOrdersToken}').child     
  marketOrders.splice(0, marketOrders.length)
  setSduiSource({source, add: true})
}`,
      },
    },

    {
      kind: 'api',
      token: 'load-invoces-list',
      spec: {
        uri: `${domen}/v1/tck/bms/tickets/item/list-invoices`,
        method: 'POST',
        data: {
          app: { type: 'func', value: '({config}) => config.custom.app' },
          token: { type: 'func', value: '({config}) => config.custom.token' },
          timezone: { type: 'func', value: `({config}) => config.custom.timezone` },
          ticket: {
            type: 'func',
            value: `({config}) => ({id: config.custom.ticketId})`,
          },
        },
      },
    },
    {
      kind: 'api',
      token: 'load-payment-types-list',
      spec: {
        uri: `${domen}/v1/tck/payment-types/list`,
        method: 'GET',
        data: {
          app: { type: 'func', value: '({config}) => config.custom.app' },
          token: { type: 'func', value: '({config}) => config.custom.token' },
          timezone: { type: 'func', value: `({config}) => config.custom.timezone` },
        },
      },
    },

    {
      kind: 'changes',
      token: 'resolve-hide-or-show-actions',
      spec: {
        target: actionsToken,
        changes: {
          'data.visible': {
            type: 'func',
            value: `({hashMap}) => !hashMap['${invocesToken}'].data.readOnly`,
          },
        },
      },
    },

    {
      kind: 'changes',
      token: 'resolve-to-edit-button',
      spec: {
        target: toEditToken,
        changes: {
          'data.visible': {
            type: 'func',
            value: `({hashMap}) => hashMap['${invocesToken}'].data.readOnly`,
          },
        },
      },
    },

    {
      kind: 'changes',
      token: 'resolve-to-readonly-button',
      spec: {
        target: toReadonlyToken,
        changes: {
          'data.visible': {
            type: 'func',
            value: `({hashMap}) => !hashMap['${invocesToken}'].data.readOnly`,
          },
        },
      },
    },

    {
      kind: 'changes',
      token: 'resolve-to-save-button',
      spec: {
        target: saveToken,
        changes: {
          'data.visible': {
            type: 'func',
            value: `({hashMap}) => !hashMap['${invocesToken}'].data.readOnly`,
          },
        },
      },
    },

    {
      kind: 'func',
      token: 'resolve-inputs-readonly',
      spec: {
        func: `({changeComponentReadonly, hashMap}) => {
  const readonly = hashMap['${invocesToken}'].data.readOnly
  const inputs = Object.values(hashMap).filter(({spec}) => spec.startsWith('input-'));
  inputs.forEach((componentData) => {
    changeComponentReadonly({ readonly, componentData });
  });
}`,
      },
    },

    {
      kind: 'func',
      token: 'set-loaded-payment-types-list',
      spec: {
        func: `({responseRequestData, hashMap}) => {
  const invoiceStatuses = responseRequestData.response.data.data.invoice_statuses
  const paymentTypesColors = ${JSON.stringify(paymentTypesColors)}
  const paymentTypesList = invoiceStatuses.map(({name, title}) => ({identifier: name, title, colorMui: paymentTypesColors[name] ?? 'default'}))
  hashMap['${invocesToken}'].data.customData.paymentTypesList = paymentTypesList
}`,
      },
    },

    {
      kind: 'changes',
      token: 'resolve-show-no-existed-invoces-text',
      spec: {
        target: noExistedInvocesToken,
        changes: {
          'data.visible': {
            type: 'func',
            value: `({responseRequestData}) => !responseRequestData.response.data?.data?.invoices?.length`,
          },
        },
      },
    },

    {
      kind: 'func',
      token: 'set-loaded-invoces-list',
      spec: {
        func: `({responseRequestData, source, hashMap, setSduiSource}) => {
  const invoices = responseRequestData.response.data.data.invoices
  const existedInvoces = source.child.find(({token}) => token === '${rootToken}').child.find(({token}) => token === '${invocesToken}').child.find(({token}) => token === '${existedInvocesToken}').child
  const addlinkItemString = hashMap['${invocesToken}'].data.customData.addItemFunc
  const addlinkItemFunc = new Function('return '+addlinkItemString)();
  const paymentTypesList = hashMap['${invocesToken}'].data.customData.paymentTypesList

  invoices.forEach(({id, name, status, url, file, total}) => {
    const existedInvoce = addlinkItemFunc.call(null, {
      id,
      minInvocePrice: ${minInvocePrice},
      maxInvocePrice: ${maxInvocePrice},
      invocesToken: '${invocesToken}',
      horisontalInvocesToken: '${existedInvocesToken}',
      domenUploadFile: '${domenUploadFile}',
      paymentTypesList,
      token: !!url ? 'add-link' : 'add-file',
      data: {id, name, status, url, file, total},
      readOnly: hashMap['${invocesToken}'].data.readOnly,
      rootToken: '${rootToken}',
      deleteButtonIcon: false,
      isStatusesSelect: true,
      valid: true,
      canChangeReadonly: false,
      deleteInvocesToken: '${deleteInvocesToken}'
    })
    existedInvoces.push(existedInvoce)
  })

  const marketOrdersData = responseRequestData.response.data.data.market_orders
  const addMarketOrderString = hashMap['${invocesToken}'].data.customData.addMarketOrderFunc
  const addMarketOrderFunc = new Function('return '+addMarketOrderString)();
  const marketOrders = source.child.find(({token}) => token === '${rootToken}').child.find(({token}) => token === '${invocesToken}').child.find(({token}) => token === '${marketOrdersToken}').child
 
  marketOrdersData.forEach(({number, title, total, status, offers}) => {
    const offersStringArr = offers.map(({title, price}) => '\\n - '+title+': '+price+' р.')

    const marketOrder = addMarketOrderFunc.call(null, {
      id: number,
      title: 'Заказ из Маркета №'+number+offersStringArr.join(''),
      price: total?.value ?? 0,
      status: status.name,
      paymentTypesList,
    })
    marketOrders.push(marketOrder)
  })

  setSduiSource({source, add: true})
}`,
      },
    },

    {
      kind: 'changes',
      token: 'set-not-first-render',
      spec: {
        target: invocesToken,
        changes: {
          'data.customData.isFirstRender': { type: 'val', value: false },
        },
      },
    },

    {
      kind: 'changes',
      token: 'add-invoces-pending',
      spec: {
        target: invocesToken,
        changes: {
          'data.pending': {
            type: 'func',
            value: `({hashMap}) => hashMap['${invocesToken}'].data.pending + 1`,
          },
        },
      },
    },

    {
      kind: 'changes',
      token: 'subtract-invoces-pending',
      spec: {
        target: invocesToken,
        changes: {
          'data.pending': {
            type: 'func',
            value: `({hashMap}) => hashMap['${invocesToken}'].data.pending - 1`,
          },
        },
      },
    },
    {
      kind: 'changes',
      token: 'show-or-hide-main-loader',
      spec: {
        target: 'main-loader',
        changes: {
          'data.visible': {
            type: 'func',
            value: `({hashMap}) => !!hashMap['${invocesToken}'].data.pending`,
          },
        },
      },
    },
  ],
};
/* eslint-enable */
